import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate } from "../../../../utils/backToTop";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import NumberOneTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberOneTemplateWidget";
import NumberTwoTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberTwoTemplateWidget";
import NumberThreeTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberThreeTemplateWidget";
import NumberFourTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberFourTemplateWidget"; 
import NumberFiveTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberFiveTemplateWidget";
import NumberSixTemplateWidget from "../../../../components/Apps/BackToTop/Template/NumberSixTemplateWidget";

//Import Tabs
import ButtonTab from "../../../../components/Apps/BackToTop/ButtonTab";
import PositionTab from "../../../../components/Apps/BackToTop/PositionTab";
import SettingTab from "../../../../components/Apps/BackToTop/SettingTab";

export default function CreateBackToTop() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Button");
    const [activeTemplateSection, setActiveTemplateSection] = useState("1_Temp");
    const [selectedLayout, setSelectedLayout] = useState("1_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("1.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Back To Top");
    const [newWidgetName, setNewWidgetName] = useState("");
    
    const [backToTopTabData, setBackToTopTabData] = useState({
        is_website_frontend: "",  
        text_title: "",     
        button_color: "",     
        icion_text_color: "",     
        border_color: "",     
        size_type: "small",     
        shape_type: "",     
        position_type: "Floating",     
        position: "",     
        position_offest: "0px",     
        scroll_position_to_display: 600,     
        setting_pages_type: "All_Pages",     
        setting_devices_type: ["Desktop","Tablets","Phones"],     
        custom_css: "",   
        custom_js: "",   
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let shape_type = "";
            let position = "";
            let text_title = "";
            let button_color = "";
            let icion_text_color = "";
            let border_color = "";
        
            switch (activeTemplateSection) {
                case "1_Temp":
                    shape_type = "normal-shape";
                    position = "bottom_right";
                    text_title = "TO TOP";
                    button_color = "#fff";
                    icion_text_color = "#000";
                    border_color = "#111";
                    break;
                case "2_Temp":
                    shape_type = "large-shape";
                    position = "bottom_right";
                    text_title = "";
                    button_color = "#fb9f00";
                    icion_text_color = "#000";
                    border_color = "";
                    break;
                case "3_Temp":
                    shape_type = "normal-shape";
                    position = "bottom_right";
                    text_title = "TO TOP";
                    button_color = "linear-gradient(131deg, #FE8100 -4.12%, #F5FF00 100%)";
                    icion_text_color = "#fff";
                    border_color = "";
                    break;
                case "4_Temp":
                    shape_type = "large-shape";
                    position = "bottom_right";
                    text_title = "TOP";
                    button_color = "#fba9002b";
                    icion_text_color = "#f19700";
                    border_color = "";
                    break;
                case "5_Temp":
                    shape_type = "large-shape";
                    position = "right";
                    text_title = "TO TOP";
                    button_color = "#fff";
                    icion_text_color = "#000";
                    border_color = "";
                    break;
                case "6_Temp":
                    shape_type = "normal-shape";
                    position = "bottom_right";
                    text_title = "Scroll To Top";
                    button_color = "#f8f8f8";
                    icion_text_color = "#000";
                    border_color = "#f8f8f8";
                    break;
                default:
                    shape_type = "";
                    position = "";
                    text_title = "";
                    button_color = "";
                    icion_text_color = "";
                    border_color = "";
            }
        
            // Update setBackToTopTabData state with the data
            setBackToTopTabData((prevData) => ({
                ...prevData,
                shape_type: shape_type,
                position: position,
                text_title: text_title,
                button_color: button_color,
                icion_text_color: icion_text_color,
                border_color: border_color,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateBackToTopTabData = (key, value) => {
        setBackToTopTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

  const menuItems = [
      { key: "Button", icon: "button.png", label: "Button" },
      { key: "Position", icon: "position.png", label: "Position" },
      { key: "Settings", icon: "setting.png", label: "Settings" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

  //Submit Review data
  const submitForm = async (e) => {
      e.preventDefault();

      setIsSubmitting(true);
      try {
        // Collect data from refs
        const settingsArray = Object.entries(backToTopTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

          // Collect data from refs
          const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "Back_To_Top",
                settings: settingsArray,
          };
          
          //Api Call
          let api_response = await submitTemplate(payload);

          //Check Responce
          if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/back-to-top');
                }, 2000); 
          } else {
              toast.error(api_response.message);
          }
      } catch (error) {
          toast.error('Oops Something Wrong. Please Try Again!' + error.message);
      } finally {
          setIsSubmitting(false);
      }
  };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Back To Top" app_type="Back_To_Top" app_slug="back-to-top"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="1_Temp" data-layout_type="1_layout" data-template_image="1.png" checked={activeTemplateSection === "1_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/back-to-top/templates/1.png`} alt="1" />
                                    </div> 
                                    <div className="content_sub">1</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="2_Temp" data-layout_type="2_layout" data-template_image="2.png" checked={activeTemplateSection === "2_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/back-to-top/templates/2.png`} alt="2" />
                                    </div>
                                    <div className="content_sub">2</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="3_Temp" data-layout_type="3_layout" data-template_image="3.png" checked={activeTemplateSection === "3_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/back-to-top/templates/3.png`} alt="3" />
                                    </div>
                                    <div className="content_sub">3</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="4_Temp" data-layout_type="4_layout" data-template_image="4.png" checked={activeTemplateSection === "4_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/back-to-top/templates/4.png`} alt="4" />
                                    </div>
                                    <div className="content_sub">4</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="5_Temp" data-layout_type="5_layout"  data-template_image="5.png" checked={activeTemplateSection === "5_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/back-to-top/templates/5.png`} alt="5" />
                                    </div>
                                    <div className="content_sub">5</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="6_Temp" data-layout_type="6_layout" data-template_image="6.png" checked={activeTemplateSection === "6_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/back-to-top/templates/6.png`} alt="6" />
                                    </div>
                                    <div className="content_sub">6</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/back-to-top/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Button" && (
                              <ButtonTab updateBackToTopTabData={updateBackToTopTabData} backToTopTabData={backToTopTabData} />
                            )}
                            {activeSection === "Position" && (
                              <PositionTab updateBackToTopTabData={updateBackToTopTabData} backToTopTabData={backToTopTabData} />
                            )}
                            {activeSection === "Settings" && (
                              <SettingTab updateBackToTopTabData={updateBackToTopTabData} backToTopTabData={backToTopTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/back-to-top"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/back-to-top/back-to-top.svg`} alt="back-to-top"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/back-to-top/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/back-to-top" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Back To Top <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "1_Temp" && (
                      <NumberOneTemplateWidget backToTopTabData={backToTopTabData} />
                    )}

                    {activeTemplateSection === "2_Temp" && (
                      <NumberTwoTemplateWidget backToTopTabData={backToTopTabData} />
                    )}

                    {activeTemplateSection === "3_Temp" && (
                      <NumberThreeTemplateWidget backToTopTabData={backToTopTabData} />
                    )}

                    {activeTemplateSection === "4_Temp" && (
                      <NumberFourTemplateWidget backToTopTabData={backToTopTabData} />
                    )}

                    {activeTemplateSection === "5_Temp" && (
                      <NumberFiveTemplateWidget backToTopTabData={backToTopTabData} />
                    )}

                    {activeTemplateSection === "6_Temp" && (
                      <NumberSixTemplateWidget backToTopTabData={backToTopTabData} />
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 